import React, { useState } from 'react'
import { Box, Popover, Typography } from '@mui/material'
import { dsColorNew } from '@palette'

export default function avgColumn(sites, avgByBranchSite) {
	return {
		name: 'name',
		setBodyCellProps: () => ({
			sx: { p: 0, verticalAlign: 'top', userSelect: 'none', cursor: 'default' },
		}),
		render: branch => <Box>
			{sites.map((site, index) => {
				const siteAvg = avgByBranchSite?.[branch]?.[site]
				return <SiteAvgCell key={`${site}-${index}`} avg={siteAvg?.avg} byLor={siteAvg?.byLor} />
			})}
		</Box>
	}
}

function SiteAvgCell({ avg, byLor }) {
	const [anchor, setAnchor] = useState(null)

	return <Box sx={{ p: 1, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
		{avg != null
			? <>
				<Box
					onClick={e => { e.stopPropagation(); setAnchor(e.currentTarget) }}
					sx={{
						cursor: 'pointer',
						bgcolor: dsColorNew.pillActiveBg,
						px: 1.5,
						py: 0.25,
						borderRadius: '6px',
						'&:hover': { opacity: 0.75 },
					}}
				>
					<Typography sx={{ fontSize: 12, color: dsColorNew.appBlue, fontWeight: 700, whiteSpace: 'nowrap' }}>
						⌀ {avg}
					</Typography>
				</Box>
				<Popover
					open={Boolean(anchor)}
					anchorEl={anchor}
					onClose={() => setAnchor(null)}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				>
					<Box sx={{ p: 2, minWidth: 140 }}>
						<Typography sx={{ fontSize: 13, fontWeight: 700, color: dsColorNew.textTitle, mb: 1 }}>Avg by LOR</Typography>
						{Object.entries(byLor || {}).map(([lor, lorAvg]) => (
							<Box key={lor} sx={{ display: 'flex', justifyContent: 'space-between', gap: 3 }}>
								<Typography sx={{ fontSize: 13, fontWeight: 600, color: dsColorNew.textDark }}>L{lor}</Typography>
								<Typography sx={{ fontSize: 13, color: dsColorNew.textDark }}>{lorAvg ?? '—'}</Typography>
							</Box>
						))}
					</Box>
				</Popover>
			</>
			: <Typography sx={{ fontSize: 12, color: dsColorNew.textSubtle }}>—</Typography>
		}
	</Box>
}
